/* eslint-disable max-lines-per-function */
import css from "classnames";
import React from "react";
import { SelectAutocomplete } from "components/haven-design/form/select";
import { fields } from "../fields";
import { Payload, Record } from "../types";
import styles from "./fields.module.css";
import Format from "./format";
import PreviewValue from "./preview-value";

type Props = {
  onSetFormat: (from: string, format: string) => void;
  onSetMapping: (from: string, to: string) => void;
  state: Payload<Record>;
}

const Fields: React.FC<Props> = ({ state, onSetMapping, onSetFormat }) => {
  if (!state.file) return null;

  const { data: [candidate] } = state;
  if (!candidate) return null;

  return (
    <div>
      <table className={css("table", "table-striped", "table-bordered", styles.table)}>
        <colgroup>
          <col style={{ width: "25%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "25%" }} />
        </colgroup>
        <thead>
          <tr>
            <th>File column</th>
            <th>Sample value</th>
            <th>Haven Connect column</th>
            <th>Formatting</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(candidate).map(header => {
            const mapping = state.mapping[header];
            const selected = mapping ? mapping.field : "none";
            return (
              <tr key={header}>
                <td className={styles.dataName}>{header}</td>
                <td className={styles.dataPreview}>
                  <PreviewValue state={state} column={header} />
                </td>
                <td className={styles.dataMapped}>
                  <SelectAutocomplete
                    margin="dense"
                    size="small"
                    disableClearable
                    autoComplete
                    fullWidth
                    getOptionLabel={(option) => fields[option].label}
                    value={selected}
                    options={Object.keys(fields)
                      .filter(
                        fieldKey => ["none", "passthrough", "add_notes", selected].includes(fieldKey) ||
                          !Object.keys(state.mapping).some(
                            fk => state.mapping[fk].field === fieldKey,
                          ),
                      )}
                    onChange={(_event, value) => value && onSetMapping(header, value)}
                    error={selected === "none"}
                  />
                </td>
                <td className={styles.dataFormat}>
                  <Format
                    onChange={format => onSetFormat(header, format)}
                    format={fields[selected].format || null}
                    value={mapping ? mapping.format : null}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Fields;
